export class DataConverter {
    constructor(id, label, createTimestamp, updateTimestamp, converterBody) {
        this.id = id;
        this.label = label;
        this.createTimestamp = createTimestamp;
        this.updateTimestamp = updateTimestamp;
        this.converterBody = converterBody;
    }
}
//# sourceMappingURL=DataConverterManager.js.map